import { combineReducers, AnyAction } from "redux";
import { LOADED_DATA, LOADED_ITEM, LOADED_RESOURCE_VISITS, LOADING_DATA, LOADING_ITEM, LOADING_RESOURCE_VISITS } from "./actions";
import { NewsState, initialNewsState, NewsItemState, itemInitialState, ResourceVisitState, resourceVisitInitialState } from "./state";

const news = (
  state: NewsState = initialNewsState,
  action: AnyAction
): NewsState => {
  const { type, payload } = action;
  if (type === LOADING_DATA) {
    return {
      ...state,
      status: "LOADING",
    };
  }
  if (type === LOADED_DATA) {
    return {
      ...state,
      status: "LOADED",
      response: payload,
      hasData: true,
    };
  }
  return state;
};

const item = (
  state: NewsItemState = itemInitialState,
  action: AnyAction
): NewsItemState => {
  const { type, payload } = action;
  switch (type) {
    case LOADING_ITEM:
      return {
        ...state,
        item: null,
        status: "LOADING",
      };
    case LOADED_ITEM:
      return {
        ...state,
        status: "LOADED",
        item: payload,
      };
    default:
      return state;
  }
};

const resourceVisits = (
  state: ResourceVisitState = resourceVisitInitialState,
  action: AnyAction
): ResourceVisitState => {
  const { type, payload } = action;
  switch (type) {
    case LOADING_RESOURCE_VISITS:
      return {
        ...state,
        resourceVisits: null,
        status: "LOADING",
      };
    case LOADED_RESOURCE_VISITS:
      return {
        ...state,
        status: "LOADED",
        resourceVisits: payload,
      };
    default:
      return state;
  }
};

export const rootReducer = combineReducers({
  news,
  item,
  resourceVisits,
});
